import React from 'react';
import clickOutside from 'react-click-outside';
import classNames from 'classnames';
import _ from 'lodash';
class Select extends React.Component {

  state = {active: false, value: ''};

  handleClickOutside() {
    if(this.state.active)
      this.setState({active: false});
  }

  componentWillMount = () => {
    this.setState({value: this.props.value})
  };

  activateDropDown = () => {
    if(!this.state.active)
      this.setState({active: true})
  };

  isTouched(){
    return this.state.value !== '';
  }

  handleSelect = e => {
    this.props.handleChange({[this.props.name]: e.target.getAttribute('value')});
    this.setState({active: false})
  };

  componentWillReceiveProps = newProps => {
    this.setState({value: newProps.value, error: newProps.errors})
  };

  isArray = () => {
    if(this.state.error)
      return Array.isArray(this.state.error.slice());
    else
      return false
  };

  viewValue = () => {
    let index =  _.findIndex(this.props.elements, el =>
      el.value === this.state.value || el.title === this.state.value
    );
    if(index !== -1)
      return this.props.elements[index].title;
    else return '';
  };

  render(){
    return(
      <div className={classNames({'input-holder': true,
                                  'select': true,
                                  'animate': true,
                                  'touched': this.isTouched(),
                                  'has-error': this.state.error,
                                  'active': this.state.active})}
           style={this.props.divStyles}
          onClick={this.activateDropDown}>
        <input className="animate-input" type="text" value={this.viewValue()} readOnly={true}/>
          <ul className="animate-select-list" style={this.props.aditionalStyles}>
            <li className="animate-select-list-item disabled" onClick={this.handleSelect} value="">{this.props.placeholder}</li>
            {this.props.elements.map( (el, i) => <li key={i} onClick={this.handleSelect} className="animate-select-list-item" value={el.value}>{el.title}</li>)}
          </ul>
          <span className="animate-arrow">
            <i className="ic-togglet-icon"/>
          </span>
          <label className="animate-label">{this.props.label}</label>
          <span className="bar" style={this.props.barStyles} />
          <span className="error-text">{this.isArray() ?  this.state.error.join(', ') : null}</span>
      </div>
    )
  }
}

export default clickOutside(Select);



// WEBPACK FOOTER //
// ./src/blocks/Select.jsx